module.exports = __webpack_public_path__ + "static/services-image-2_d-117e56e6a397bd227e861a5e2e77de8a.jpg";